import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { TableFetchParams, tableQueryMaker, TableState } from '@core/table';
import { useService } from '@core/inversify-react';

import { declarationKeys, DeclarationTableContext } from '@modules/declarations';

import { GetBoxDeclarationsRepoType, IGetBoxDeclarationsRepo } from '../../repos';

export const useBoxDeclarationsTableContext = () => {
  const getBoxDeclarationsRepo = useService<IGetBoxDeclarationsRepo>(GetBoxDeclarationsRepoType);
  const { id } = useParams<{ id: string }>();

  const onFetch = useCallback(
    async (params: TableFetchParams) => {
      const result = await getBoxDeclarationsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getBoxDeclarationsRepo],
  );

  const defaultState = useMemo<Partial<TableState>>(
    () => ({
      hiddenColumns: [declarationKeys.flightName, declarationKeys.editedBy.name, declarationKeys.planCategory.name, declarationKeys.wardrobeNumber],
      filters: [{ id: declarationKeys.parcelId, value: id }],
    }),
    [id],
  );

  return { onFetch, context: DeclarationTableContext, defaultState };
};
